var _rect, _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgResetPasswordSuccess = function SvgResetPasswordSuccess(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 72,
    rx: 8,
    fill: "currentColor",
    fillOpacity: 0.05
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.5 34.125H45.8438V25.375C45.8438 22.6133 43.6055 20.375 40.8438 20.375H31.1562C28.3945 20.375 26.1562 22.6133 26.1562 25.375V34.125H23.5C22.8086 34.125 22.25 34.6836 22.25 35.375V50.375C22.25 51.0664 22.8086 51.625 23.5 51.625H48.5C49.1914 51.625 49.75 51.0664 49.75 50.375V35.375C49.75 34.6836 49.1914 34.125 48.5 34.125ZM37.0938 43.3828V45.4531C37.0938 45.625 36.9531 45.7656 36.7812 45.7656H35.2188C35.0469 45.7656 34.9062 45.625 34.9062 45.4531V43.3828C34.5838 43.1513 34.3431 42.8235 34.2189 42.4465C34.0946 42.0695 34.0932 41.6628 34.2148 41.2849C34.3364 40.907 34.5747 40.5775 34.8955 40.3437C35.2163 40.11 35.6031 39.984 36 39.984C36.3969 39.984 36.7837 40.11 37.1045 40.3437C37.4253 40.5775 37.6636 40.907 37.7852 41.2849C37.9068 41.6628 37.9054 42.0695 37.7811 42.4465C37.6569 42.8235 37.4162 43.1513 37.0938 43.3828ZM43.0312 34.125H28.9688V25.375C28.9688 24.168 29.9492 23.1875 31.1562 23.1875H40.8438C42.0508 23.1875 43.0312 24.168 43.0312 25.375V34.125Z",
    fill: "currentColor"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgResetPasswordSuccess, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/reset-password-success.f470c362.svg";
export { ForwardRef as ReactComponent };